<template>
    <div>
        <vue-good-wizard
                :steps="steps"
                class="mb-3"
                style="border-color: transparent;"
                :onNext="nextClicked"
                :onBack="backClicked">
            <div slot="page1">
                <!--                        <p v-if="auth.auth[0] == null" align="center"><bar-loader  class="custom-class" color="#6d0606" loading="loading" :size="150" sizeUnit="px"></bar-loader></p>-->
                <Form>
                    <b-row form>
                        <b-col md="6">
                            <b-form-group>
                                <Label for="orgName">Company Name<span style="color: red !important; display: inline; float: none;">*</span></Label>
                                <b-form-input @input="filterOutBadChar()"  v-model="model.orgName" type="text" name="orgName" id="orgName"
                                              placeholder="Company Name"/>
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group>
                                <Label for="orgIncNumber">Incorporation Number <span style="color: red !important; display: inline; float: none;">*</span></Label>
                                <b-form-input @input="filterOutBadChar()"  v-model="model.orgIncNumber" type="text" name="orgIncNumber" id="orgIncNumber"
                                              :placeholder="$t('auth.incorporationNumberPlaceholder')"/>
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group>
                                <Label for="orgIncDate">Incorporation Date <span style="color: red !important; display: inline; float: none;">*</span></Label>
                                <b-form-input @input="filterOutBadChar()" v-model="model.orgIncDate" type="date" name="orgIncDate" id="orgIncDate"
                                              :placeholder="$t('auth.incorporationDatePlaceholder')"/>
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group>
                                <Label for="orgType">Organisation Type <span style="color: red !important; display: inline; float: none;">*</span></Label>
                                <select v-model="model.orgType" class="form-control">
                                    <option value="" selected="selected">- Select -</option>
                                    <option value="Limited Liability">Limited Liability</option>
                                    <option value="Public Limited Company (PLC)">Public Limited Company (PLC)</option>
                                    <option value="Sole Proprietorship">Sole Proprietorship</option>
                                    <option value="Association">Association</option>
                                    <option  value="Non-profit Organisation">Non-profit Organisation</option>
                                    <option value="Partnership">Partnership</option>
                                    <option value="Enterprises/Business Names">Enterprises/Business Names</option>
                                </select>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </Form>
            </div>
            <div slot="page2">
                <Form>
                    <b-row form>
                        <b-col md="6">
                            <b-form-group>
                                <Label for="orgCountry">Country <span style="color: red !important; display: inline; float: none;">*</span></Label>
                                <country-select class="form-control" :countryName="true" :regionName="true" v-model="model.orgCountry" :country="model.orgCountry" topCountry="NG" />
                            </b-form-group>
                        </b-col>
                        <b-col  md="6">
                            <b-form-group>
                                <Label for="orgIncNumber">State <span style="color: red !important; display: inline; float: none;">*</span></Label>
                                <region-select class="form-control" :regionName="true" :countryName="true" v-model="model.orgState" :country="model.orgCountry" :region="model.orgState" />
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group>
                                <Label for="orgCity">City <span style="color: red !important; display: inline; float: none;">*</span></Label>
                                <b-form-input @input="filterOutBadChar()" v-model="model.orgCity" type="text" name="orgCity" id="orgCity"
                                              :placeholder="$t('auth.parentCompanyCityPlaceholder')"/>
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group>
                                <Label for="orgStreet">Street <span style="color: red !important; display: inline; float: none;">*</span></Label>
                                <b-form-input @input="filterOutBadChar()" v-model="model.orgStreet" type="text" name="orgStreet" id="orgStreet"
                                              :placeholder="$t('auth.parentCompanyStreetPlaceholder')"/>
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group >
                                <Label for="orgPhone">Phone Number <span style="color: red !important; display: inline; float: none;">*</span></Label>
                                <b-form-input @input="filterOutBadChar()" v-model="model.orgPhone" type="text" name="phone" id="orgPhone"
                                              :placeholder="$t('auth.phoneNumberCompanyPlaceholder')"/>
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group >
                                <Label for="orgEmail">Company Email <span style="color: red !important; display: inline; float: none;">*</span></Label>
                                <b-form-input @input="filterOutBadChar()" v-model="model.orgEmail" type="email" name="email" id="orgEmail"
                                              placeholder="Company Email"/>
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group >
                                <Label for="orgWebsite">Website </Label>
                                <b-form-input @input="filterOutBadChar()" v-model="model.orgWebsite" type="text" name="orgWebsite" id="orgWebsite"
                                              :placeholder="$t('auth.websitePlaceholder')"/>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </Form>
            </div>
            <div slot="page3">
                <strong>{{$t('auth.confirmReview')}}. <span @click="exportPDF()" class="btn btn-sm btn-outline-info" >Download<b-icon-download /></span></strong>
                <br><br>
                <div id="newOrgForm">
                    <table class="table">
                        <tr>
                            <th>Details</th>
                            <th><p style="color: white;">-</p></th>
                        </tr>
                        <tr>
                            <td style="font-size: 14px;">Company Name:</td>
                            <td colspan="4" style="font-size: 14px; color: red;" v-if="model.orgName === ''" > Mandatory</td>
                            <td colspan="4" style="font-size: 14px;" v-else> {{model.orgName}}</td>
                        </tr>
                        <tr>
                            <td style="font-size: 14px;">Incorporation Number:</td>
                            <td colspan="4" style="font-size: 14px; color: red;" v-if="model.orgIncNumber === ''" > Mandatory</td>
                            <td colspan="4" style="font-size: 14px;" v-else> {{model.orgIncNumber}}</td>
                        </tr>
                        <tr>
                            <td style="font-size: 14px;">Incorporation Date:</td>
                            <td colspan="4" style="font-size: 14px; color: red;" v-if="model.orgIncDate === ''" > Mandatory</td>
                            <td colspan="4" style="font-size: 14px;" v-else> {{ model.orgIncDate }} </td>
                        </tr>
                        <tr>
                            <td style="font-size: 14px;">Company Type:</td>
                            <td colspan="4" style="font-size: 14px; color: red;" v-if="model.orgType === ''" > Mandatory</td>
                            <td colspan="4" style="font-size: 14px;" v-else> {{model.orgType}}</td>
                        </tr>
                        <tr>
                            <td style="font-size: 14px;">Country:</td>
                            <td colspan="4" style="font-size: 14px; color: red;" v-if="model.orgCountry === ''" > Mandatory</td>
                            <td colspan="4" style="font-size: 14px;" v-else> {{model.orgCountry}}</td>
                        </tr>
                        <tr>
                            <td style="font-size: 14px;">State:</td>
                            <td colspan="4" style="font-size: 14px; color: red;" v-if="model.orgState === ''" > Mandatory</td>
                            <td colspan="4" style="font-size: 14px;" v-else> {{model.orgState}}</td>
                        </tr>
                        <tr>
                            <td style="font-size: 14px;">City:</td>
                            <td colspan="4" style="font-size: 14px; color: red;" v-if="model.orgCity === ''" > Mandatory</td>
                            <td colspan="4" style="font-size: 14px;" v-else> {{model.orgCity}}</td>
                        </tr>
                        <tr>
                            <td style="font-size: 14px;">Street:</td>
                            <td colspan="4" style="font-size: 14px; color: red;" v-if="model.orgStreet === ''" > Mandatory</td>
                            <td colspan="4" style="font-size: 14px;" v-else> {{model.orgStreet}}</td>
                        </tr>
                        <tr>
                            <td style="font-size: 14px;">Phone Number:</td>
                            <td colspan="4" style="font-size: 14px; color: red;" v-if="model.orgPhone === ''" > Mandatory</td>
                            <td colspan="4" style="font-size: 14px;" v-else> {{model.orgPhone}}</td>
                        </tr>
                        <tr>
                            <td style="font-size: 14px;">Email:</td>
                            <td colspan="4" style="font-size: 14px; color: red;" v-if="model.orgEmail === ''" > Mandatory</td>
                            <td colspan="4" style="font-size: 14px;" v-else> {{model.orgEmail}}</td>
                        </tr>
                        <tr>
                            <td style="font-size: 14px;">Website:</td>
                            <td colspan="4" style="font-size: 14px;" v-if="model.orgWebsite === ''" > Not Mandatory}</td>
                            <td colspan="4" style="font-size: 14px;" v-else> {{model.orgWebsite}}</td>
                        </tr>
                    </table>
                </div>
            </div>
        </vue-good-wizard>
        <template>
            <loading :active.sync="auth.authLoading"
                     :can-cancel="false"
                     color="#6d0606"
                     :is-full-page="fullPage"></loading>
        </template>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import Loading from 'vue-loading-overlay';
    // import AuthBaseButton from "../button/AuthBaseButton";
    // import BaseButton from "../button/BaseButton";
    import "../../assets/js/lumbex"
    import jsPdf from "jspdf";
    //import Vue from "vue";
    export default {
        name: "ForgotForm",
        // props:["propScreen"],
        components:{
            Loading,
            // AuthBaseButton,
            // BaseButton
        },
        data() {
            return {
                fullPage:true,
                companies:[],
                hasParent: false,
                orgScreen: 'stepOne',
                model: {
                    orgName: '',
                    orgIncNumber: '',
                    accountNumber:'',
                    orgIncDate: '',
                    orgType:'',
                    orgCountry:'',
                    orgSector:'',
                    orgState:'',
                    orgCity:'',
                    orgStreet:'',
                    orgAddressOne:'',
                    orgAddressTwo:'',
                    orgTaxIdentificationNumber:'',
                    orgCertificateToCommenceBusiness:'',
                    orgOtherReferenceNumber:'',
                    orgPhone:'',
                    orgEmail:'',
                    orgWebsite:'',
                    orgUserID:'',
                    orgCustId:'',
                    requestId:'7d4558135efb4fedb524ba1a5127a093',
                    countryId:'',
                    requestType:'auth',
                    subscribe: true
                },
                model1: {
                    username: '',
                    subscribe: true
                },
                steps: [
                    {
                        label: 'Details',
                        slot: 'page1',
                    },
                    {
                        label: 'Address',
                        slot: 'page2',
                    },
                    {
                        label: 'Confirm',
                        slot: 'page3',
                    }
                ],
            }
        },
        methods: {
            exportPDF() {
                let pdf = new jsPdf('p', 'pt', 'a4');
                // const pdf = new jsPdf({
                //     orientation: 'landscape',
                //     unit: 'in',
                //     format: [4, 2]
                // });
                //A4 - 595x842 pts\
                // let options = {
                //     pagesplit: true
                // };
                let html = document.getElementById('newOrgForm').innerHTML;
                // let html = '<h1>GOOD MEMO</h1>'
                pdf.fromHTML(html,15,15,{
                    width:150
                })
                pdf.save( 'auth-form.pdf')

            },
            filterOutBadChar(){
                // this.model.orgIncNumber = this.model.orgIncNumber.replace(/[^A-Z0-9]/i, '')
                // this.model.orgName = this.model.orgName.replace(/[^A-Z0-9]/i, '')
                // this.model.orgSector = this.model.orgSector.replace(/[^A-Z]/i, '')
                // this.model.orgState = this.model.orgState.replace(/[^A-Z0-9]/i, '')
                // this.model.orgCity = this.model.orgCity.replace(/[^A-Z]/i, '')
                // this.model.orgStreet = this.model.orgStreet.replace(/[^A-Z0-9]/i, '')
                // this.model.orgAddressOne = this.model.orgAddressOne.replace(/[^A-Z0-9]/i, '')
                // this.model.orgAddressTwo = this.model.orgAddressTwo.replace(/[^A-Z0-9]/i, '')
                // this.model.orgTaxIdentificationNumber = this.model.orgTaxIdentificationNumber.replace(/[^A-Z0-9]/i, '')
                // this.model.orgCertificateToCommenceBusiness  = this.model.orgCertificateToCommenceBusiness .replace(/[^A-Z0-9]/i, '')
                // this.model.orgOtherReferenceNumber = this.model.orgOtherReferenceNumber.replace(/[^A-Z0-9]/i, '')
                // this.model.orgPhone = this.model.orgPhone.replace(/[^0-9]/i, '')
            },
            nextClicked(currentPage) {
                console.log('next clicked', currentPage)
                if (currentPage >= this.steps.length-1)
                    this.createCompany()
                return true; //return false if you want to prevent moving to next page
            },
            backClicked(currentPage) {
                console.log('back clicked', currentPage);
                return true; //return false if you want to prevent moving to previous page
            },
            async createCompany(){
                this.model.orgIncDate = this.$moment(this.model.orgIncDate).format('YYYY-MM-DD')
                console.log(this.model.orgIncDate)
                if (this.model.orgName !== ''
                    && this.model.orgIncNumber !== ''
                    && this.model.orgIncDate !== ''
                    && this.model.orgType !== ''
                    && this.model.orgCountry !== ''
                    && this.model.orgState !== ''
                    && this.model.orgCity !== ''
                    && this.model.orgStreet !== ''
                    && this.model.orgPhone !== ''
                    && this.model.orgEmail !== ''
                ) {
                    this.model.orgUserID = this.auth.userInfo.id;
                    this.model.firstName = this.auth.userInfo.firstName;
                    this.model.lastName = this.auth.userInfo.lastName;
                    await this.$store.dispatch('auth/createCompany', this.model, {root: true})

                }else{
                    this.$swal('Error!','Empty field detected. Please fill fields with the (*)','error')
                }
            },
            navigate(orgScreen){
                this.model.otp = ''
                this.$store.commit('auth/updateOrgScreen', orgScreen, {root: true})
            },
            // checkAccountNumber(){
            //     this.model.dialogs = this.$dialogs
            //     this.model.otp = ''
            //     this.$store.dispatch('auth/verifyAccount', this.model, {root: true})
            // },
            // verifyAccountNumber(){
            //     this.model.dialogs = this.$dialogs
            //     this.model.orgUserID = this.auth.userInfo.id;
            //     this.model.firstName = this.auth.userInfo.firstName;
            //     this.model.lastName = this.auth.userInfo.lastName;
            //     this.$store.dispatch('auth/getAccountDetails', this.model, {root: true})
            // }
        },
        computed:{
            ...mapState([
                'auth',
                'document',
                'officer',
            ]),
        },
        mounted() {
            this.$store.commit('auth/updateOrgScreen', 'stepTwo')
        }
    }
</script>

<style scoped>
    /*@import "../../assets/style/css/lucas.css";*/
    /*@import "../../assets/style/css/luminous.css";*/
</style>